import { render, staticRenderFns } from "./checkRiskJiaohu.vue?vue&type=template&id=f4c7bfe6&scoped=true&"
import script from "./checkRiskJiaohu.vue?vue&type=script&lang=js&"
export * from "./checkRiskJiaohu.vue?vue&type=script&lang=js&"
import style0 from "./checkRiskJiaohu.vue?vue&type=style&index=0&id=f4c7bfe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c7bfe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4c7bfe6')) {
      api.createRecord('f4c7bfe6', component.options)
    } else {
      api.reload('f4c7bfe6', component.options)
    }
    module.hot.accept("./checkRiskJiaohu.vue?vue&type=template&id=f4c7bfe6&scoped=true&", function () {
      api.rerender('f4c7bfe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/checkRiskJiaohu.vue"
export default component.exports